import React from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog, snackbar } from 'components'
import { useApiCall } from 'hooks'

import { deleteParkingConfig } from '../api'
import { DeleteParkingConfigResponse } from '../types'

interface DeleteParkingConfigDialogProps {
  handleClose: () => void
  onDone: () => void
  parkingConfigId: number
  parkingConfigTitle: string
}

const DeleteParkingConfigDialog: React.FC<DeleteParkingConfigDialogProps> = ({
  handleClose,
  parkingConfigId,
  parkingConfigTitle,
  onDone,
}) => {
  const { t } = useTranslation()
  const [deleteParkingConfigApi, isLoading] = useApiCall<number, DeleteParkingConfigResponse>(
    deleteParkingConfig,
  )

  const onDelete = async () => {
    try {
      await deleteParkingConfigApi(parkingConfigId)
      onDone()
    } catch (err) {
      console.error(err)
      snackbar.show(t('parking:errors.deleteFailed') as string)
    }
  }

  return (
    <Dialog
      title={t('parking:deleteTitle', { title: parkingConfigTitle }) as string}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText={t('parking:delete') as string}
      okButtonProps={{ disabled: isLoading }}
      onAccept={onDelete}
    />
  )
}

export { DeleteParkingConfigDialog }
